<script setup>
import { useGlobalStore } from "@stores/global";

const globalStore = useGlobalStore();

const tabs = [
    { id: "getStarted", label: "Go Places" },
    { id: "featuredActivities", label: "Featured" },
    { id: "countdown", label: "Countdown" },
    { id: "extras", label: "Extras" },
];
</script>

<template>
    <div
        v-if="globalStore.activePage === 'explore'"
        class="-mx-6 -mt-6 flex lg:hidden"
    >
        <button
            v-for="tab in tabs"
            :key="tab.id"
            :class="[
                'body-xs flex h-10 flex-1 items-center justify-center px-4 leading-none font-bold uppercase transition-colors max-[355px]:text-[8px]',
                globalStore.mobilePanel === tab.id
                    ? 'bg-marine-900 text-yellow-400'
                    : 'bg-marine-700 faded-text',
            ]"
            @click="globalStore.setMobilePanel(tab.id)"
        >
            {{ tab.label }}
        </button>
    </div>
</template>
